export default "__VITE_ASSET__CuveKsx8__"